import { observer } from 'mobx-react-lite';
import React from 'react';

import { useOnBoardingDrawer } from '../../OnBoardingDrawerProvider';
import CreatedPatientDoneView from './CreatedPatientDoneView';
import PatientDetailesForm from './PatientDetailesForm';

const PatientDetailes = () => {
  const {
    contextData: { patient },
  } = useOnBoardingDrawer();

  return patient?.uuid ? <CreatedPatientDoneView /> : <PatientDetailesForm />;
};

export default observer(PatientDetailes);
